module.exports = __webpack_public_path__ + "img/download-2-1INT.c9996601.png";